import { connect } from 'react-redux';

import { selectors as createSelectors } from 'dux/createInstance';
import FlavorSelector from './FlavorSelector';

function mapStateToProps(state) {
  return {
    selectedFlavor: createSelectors.selectedFlavorSelector(state),
  };
}

export default connect(mapStateToProps, null)(FlavorSelector);
